import { useRequiredContext } from "@redotech/react-util/context";
import { DEFAULT_MERCHANT_TIMEZONE } from "@redotech/redo-common-model/timezone-list";
import { TeamContext } from "@redotech/redo-web/context/team-context";

/** Same fallback as getMerchantIANATimezone on the server. */
export function useMerchantTimeZone(): string {
  const team = useRequiredContext(TeamContext);
  return team._shopify?.iana_timezone ?? DEFAULT_MERCHANT_TIMEZONE;
}
